var messages$1 = {
	"button.continue": [
		"Continue"
	],
	"button.continueWithEmail": [
		"Continue with email"
	],
	"button.createAnOrganization": [
		"Create an organization"
	],
	"button.emailCode": [
		"Email me a code"
	],
	"button.emailLink": [
		"Email me a link"
	],
	"button.emailResent": [
		"Email resent! Try again in ",
		[
			"timeRemaining"
		],
		"s"
	],
	"button.goBack": [
		"Go back"
	],
	"button.hidePassword": [
		"Hide"
	],
	"button.loginWithoutPassword": [
		"Log in without a password"
	],
	"button.resendEmail": [
		"Resend email"
	],
	"button.retry": [
		"Try again"
	],
	"button.showPassword": [
		"Show"
	],
	"button.totpQrManual": [
		"Having trouble scanning?"
	],
	"button.totpQrRetry": [
		"Try to scan the QR code again"
	],
	"button.tryDifferentEmailAddress": [
		"Try a different email address"
	],
	"button.usePassword": [
		"Use a password instead"
	],
	"emailConfirmation.content": [
		"An email was sent to <bold>",
		[
			"email"
		],
		"</bold>."
	],
	"emailConfirmation.emailSent": [
		"Email sent! Try again in ",
		[
			"timeRemaining"
		],
		"s"
	],
	"emailConfirmation.title": [
		"Check your email"
	],
	"emailMethodSelection.code": [
		"Email me a login code"
	],
	"emailMethodSelection.link": [
		"Email me a login link"
	],
	"emailMethodSelection.title": [
		"Select how you’d like to continue"
	],
	"emailVerification.content": [
		"Confirm your email address with one of the following:"
	],
	"emailVerification.title": [
		"Verify your email"
	],
	"error.adBlockerDetected": [
		"The request was blocked by an Ad Blocker. Please disable your ad blocker, refresh the page, and try again."
	],
	"error.authPolicyNoOrg": [
		"Unable to join due to the organization's authentication policy. Please contact your admin for more information."
	],
	"error.authPolicyWithOrg": [
		"Unable to join due to ",
		[
			"organizationName"
		],
		"'s authentication policy. Please contact your admin for more information."
	],
	"error.breachedPassword": [
		"Password appears in the list of breached passwords and must be reset."
	],
	"error.claimedDomain": [
		"Your email domain is associated with a particular organization, so you are unable to join or create other organizations. Please contact your admin for more information."
	],
	"error.default": [
		"Something went wrong. Try again later or contact your admin for help."
	],
	"error.duplicatePhoneNumber": [
		"A member with the specified phone number already exists for this organization."
	],
	"error.emailNoAccessToOrg": [
		[
			"email"
		],
		" does not have access to ",
		[
			"organizationName"
		],
		". If you think this is a mistake, contact your admin."
	],
	"error.emailNotFound": [
		"Email not found."
	],
	"error.eml": [
		"Something went wrong. Your login link may have expired, been revoked, or been used more than once. Request a new login link to try again, or contact your admin for help."
	],
	"error.inactiveEmail": [
		"The email address is marked as inactive. Please try another email address, or contact your admin if you think this is a mistake."
	],
	"error.invalidCode": [
		"Code format is invalid, please try again."
	],
	"error.invalidEmail": [
		"Email format is invalid."
	],
	"error.invalidEmailAddress": [
		"Invalid email address"
	],
	"error.invalidPhoneNumber": [
		"Phone number format is invalid. Ensure the phone number is in the E.164 format."
	],
	"error.invalidPhoneNumberCountryCode": [
		"The phone number's country code is invalid, unsupported, or disabled."
	],
	"error.invalidSessionToken": [
		"Invalid session token."
	],
	"error.jitIneligible": [
		[
			"email"
		],
		" does not have access to ",
		[
			"organizationName"
		],
		". If you think this is a mistake, contact your admin"
	],
	"error.memberPasswordNotFound": [
		"Member password not found."
	],
	"error.noUserPassword": [
		"Password not found for this user. Please try again."
	],
	"error.oauthFlowCallbackError": [
		"An error was encountered in the callback of the OAuth flow. Please try again."
	],
	"error.oauthTokenNotFound": [
		"OAuth Token could not be found."
	],
	"error.organization": [
		"The organization you are looking for could not be found. If you think this is a mistake, contact your admin."
	],
	"error.otpCodeNotFound": [
		"Invalid passcode, please try again."
	],
	"error.passcodeInvalid": [
		"Invalid passcode, please try again."
	],
	"error.resetPassword": [
		"Password must be reset."
	],
	"error.sessionNotFound": [
		"Session not found."
	],
	"error.title": [
		"Looks like there was an error!"
	],
	"error.unableToAuthMagicLink": [
		"The magic link could not be authenticated because it was either already used or expired. Please try again."
	],
	"error.unauthorizedAction": [
		"Unauthorized action."
	],
	"error.unauthorizedCredentials": [
		"Unauthorized credentials."
	],
	"error.unsubscribedPhoneNumber": [
		"Phone number is unsubscribed. User has unsubscribed. Resubscribe by texting 'START' before messages can be sent."
	],
	"error.userLockLimitReached": [
		"Too many failed authentication attempts. Please try again later."
	],
	"error.userUnauthenticated": [
		"Must have an active session to call this method. Have you logged in yet?"
	],
	"formField.backupCode.ariaLabel": [
		"Backup code"
	],
	"formField.backupCode.placeholder": [
		"Enter backup code"
	],
	"formField.countryCode.label": [
		"Country code"
	],
	"formField.email.label": [
		"Email"
	],
	"formField.email.placeholder": [
		"example@email.com"
	],
	"formField.orgSlug.label": [
		"Organization slug"
	],
	"formField.otp.ariaLabel": [
		"One-time passcode"
	],
	"formField.passcode.status.verifying": [
		"Verifying passcode..."
	],
	"formField.password.label": [
		"Password"
	],
	"formField.phone.label": [
		"Phone number"
	],
	"idpConsent.allowClientTo": [
		"Allow ",
		[
			"clientName"
		],
		" to:"
	],
	"idpConsent.button.allow": [
		"Allow"
	],
	"idpConsent.button.deny": [
		"Deny"
	],
	"idpConsent.customScopes.title": [
		[
			"clientName"
		],
		" wants to access your ",
		[
			"projectName"
		],
		" account"
	],
	"idpConsent.defaultClientName": [
		"The App"
	],
	"idpConsent.denied": [
		"Access to the application was denied."
	],
	"idpConsent.noActiveSession": [
		"No active session detected. Please log in to continue."
	],
	"idpConsent.noPermissionsToGrant": [
		"You do not have permissions to grant ",
		[
			"clientName"
		],
		" access to some of the requested scopes."
	],
	"idpConsent.signIn.title": [
		"Sign in to ",
		[
			"clientName"
		],
		" with ",
		[
			"projectName"
		]
	],
	"idpLogout.confirmMessage": [
		"Are you sure you want to log out of your ",
		[
			"projectName"
		],
		" account?"
	],
	"idpLogout.no": [
		"No"
	],
	"idpLogout.notLoggedOut": [
		"You have not been logged out. You may close this page."
	],
	"idpLogout.title": [
		"Log out?"
	],
	"idpLogout.yes": [
		"Yes"
	],
	"link.openInGmail": [
		"Open in Gmail"
	],
	"link.openInOutlook": [
		"Open in Outlook"
	],
	"link.openInYahoo": [
		"Open in Yahoo"
	],
	"link.signupResetPassword": [
		"Sign up or reset password"
	],
	"loading.label": [
		"Loading"
	],
	"login.loading": [
		"Logging in..."
	],
	"login.success.content": [
		"You have successfully logged in."
	],
	"login.title": [
		"Sign up or log in"
	],
	"methodDivider.text": [
		"or"
	],
	"mfa.enrollment.content": [
		"Your organization requires an additional form of verification to make your account more secure."
	],
	"mfa.enrollment.option.sms": [
		"Text me a code"
	],
	"mfa.enrollment.option.totp": [
		"Use an authenticator app"
	],
	"mfa.enrollment.title": [
		"Set up Multi-Factor Authentication"
	],
	"mfa.methods.authenticatorApp": [
		"Use an authenticator app"
	],
	"mfa.smsEnrollment.content": [
		"Your organization requires an additional form of verification to make your account more secure."
	],
	"mfa.smsEnrollment.title": [
		"Enter your phone number to set up Multi-Factor Authentication"
	],
	"mfa.totpEnrollment.content": [
		"Click to copy the code below. Enter into your authenticator app to link your account."
	],
	"mfa.totpEnrollment.copyCode.codeCopied": [
		"Copied!"
	],
	"mfa.totpEnrollment.copyCode.label": [
		"Copy to clipboard"
	],
	"mfa.totpEnrollment.title": [
		"Having trouble scanning the QR code?"
	],
	"mfa.totpEnrollment.toast.copyFailed": [
		"Couldn't copy code to clipboard"
	],
	"mfa.totpEntry.getNewCode": [
		"If the verification code doesn’t work, go back to your authenticator app to get a new code."
	],
	"mfa.totpEntry.switchToSms": [
		"Text me a code instead"
	],
	"mfa.totpEntry.useBackupCode": [
		"Use a backup code"
	],
	"mfaTotpEnrollment.qrAltText": [
		"QR code for TOTP enrollment"
	],
	"oauth.continueWithGitHub": [
		"Continue with GitHub"
	],
	"oauth.continueWithGoogle": [
		"Continue with Google"
	],
	"oauth.continueWithHubSpot": [
		"Continue with HubSpot"
	],
	"oauth.continueWithMicrosoft": [
		"Continue with Microsoft"
	],
	"oauth.continueWithSlack": [
		"Continue with Slack"
	],
	"organizationDiscovery.acceptInvite": [
		"Accept Invite"
	],
	"organizationDiscovery.join": [
		"Join"
	],
	"organizationDiscovery.noOrgs.content": [
		"Make sure your email address is correct. Otherwise, you might need to be invited by your admin."
	],
	"organizationDiscovery.noOrgs.create.content": [
		[
			"email"
		],
		" does not have an account. Think this is a mistake? Try a different email address, or contact your admin."
	],
	"organizationDiscovery.noOrgs.create.title": [
		"Create an organization to get started"
	],
	"organizationDiscovery.noOrgs.title": [
		[
			"email"
		],
		" does not belong to any organizations."
	],
	"organizationDiscovery.title": [
		"Select an organization to continue"
	],
	"organizationLogin.title": [
		"Continue to ",
		[
			"organizationName"
		]
	],
	"organizationLogin.titleUnknown": [
		"Continue to ..."
	],
	"passcode.codeSent": [
		"Code sent! Try again in ",
		[
			"timeRemaining"
		],
		"s"
	],
	"passcode.expirationCountdown": [
		"Your code expires in ",
		[
			"timeRemaining"
		],
		"."
	],
	"passcode.expired": [
		"Your code has expired."
	],
	"passcode.resendCode": [
		"Resend code"
	],
	"passcode.sentConfirmation": [
		"A 6-digit passcode was sent to you at <bold>",
		[
			"destination"
		],
		"</bold>."
	],
	"passcode.title": [
		"Enter passcode"
	],
	"password.forgot.content.discovery": [
		"We'll email you a verification link to sign up for an account or reset your password if you have one."
	],
	"password.forgot.content.organization": [
		"We'll email you a login link to sign in to your account directly or reset your password if you have one."
	],
	"password.forgot.title": [
		"Check your email for help signing in"
	],
	"password.login.title": [
		"Log in with email and password"
	],
	"password.requirement.fulfilled": [
		"Fulfilled"
	],
	"password.requirement.notFulfilled": [
		"Not fulfilled"
	],
	"password.requirement.suggestion": [
		"Suggestion"
	],
	"password.requirement.warning": [
		"Warning"
	],
	"password.reset.emailSent.content": [
		"A login link was sent to you at <bold>",
		[
			"email"
		],
		"</bold>."
	],
	"password.reset.emailSent.title": [
		"Check your email"
	],
	"password.setNew.title": [
		"Set a new password"
	],
	"password.strength": [
		"Password strength: ",
		[
			"score"
		],
		" out of 4."
	],
	"password.strength.accepted": [
		"Password accepted."
	],
	"password.strength.notAccepted": [
		"Password not accepted."
	],
	"password.strength.requirementsNotMet": [
		"Your password must meet all requirements."
	],
	"password.strengthError.breached": [
		"This password may have been used on a different site that experienced a security issue. Please choose another password."
	],
	"password.strengthError.complexity": [
		[
			"complexity",
			"plural",
			{
				one: [
					"Must contain ",
					"#",
					" of the following: uppercase letter, lowercase letter, number, symbol"
				],
				other: [
					"Must contain ",
					"#",
					" of the following: uppercase letter, lowercase letter, number, symbol"
				]
			}
		]
	],
	"password.strengthError.minimumLength": [
		[
			"characterLength",
			"plural",
			{
				one: [
					"Must be at least ",
					"#",
					" character long"
				],
				other: [
					"Must be at least ",
					"#",
					" characters long"
				]
			}
		]
	],
	"password.verification.content": [
		"A login link was sent to you at <bold>",
		[
			"email"
		],
		"</bold>."
	],
	"password.verification.title": [
		"Verify your email first."
	],
	"password.zxcvbn.suggestion.addWords": [
		"Add another word or two. Uncommon words are better."
	],
	"password.zxcvbn.suggestion.allUppercase": [
		"All-uppercase is almost as easy to guess as all-lowercase."
	],
	"password.zxcvbn.suggestion.avoidDatesAndYearsAssociatedWithYou": [
		"Avoid dates and years that are associated with you."
	],
	"password.zxcvbn.suggestion.avoidRecentYears": [
		"Avoid recent years."
	],
	"password.zxcvbn.suggestion.avoidRepeats": [
		"Avoid repeated words and characters."
	],
	"password.zxcvbn.suggestion.avoidSequences": [
		"Avoid sequences."
	],
	"password.zxcvbn.suggestion.avoidYearsAssociatedWithYou": [
		"Avoid years that are associated with you."
	],
	"password.zxcvbn.suggestion.capitalization": [
		"Capitalization doesn't help very much."
	],
	"password.zxcvbn.suggestion.longerKeyboardPattern": [
		"Use a longer keyboard pattern with more turns."
	],
	"password.zxcvbn.suggestion.noSymbolsDigitsUppercase": [
		"No need for symbols, digits, or uppercase letters."
	],
	"password.zxcvbn.suggestion.predictableSubstitutions": [
		"Predictable substitutions like '@' instead of 'a' don't help very much."
	],
	"password.zxcvbn.suggestion.reversed": [
		"Reversed words aren't much harder to guess."
	],
	"password.zxcvbn.suggestion.useAFewWords": [
		"Use a few words, avoid common phrases."
	],
	"password.zxcvbn.warning.commonNames": [
		"Common names and surnames are easy to guess."
	],
	"password.zxcvbn.warning.dates": [
		"Dates are often easy to guess."
	],
	"password.zxcvbn.warning.longerRepeats": [
		"Repeats like \"abcabcabc\" are only slightly harder to guess than \"abc\"."
	],
	"password.zxcvbn.warning.names": [
		"Names and surnames by themselves are easy to guess."
	],
	"password.zxcvbn.warning.recentYears": [
		"Recent years are easy to guess."
	],
	"password.zxcvbn.warning.repeats": [
		"Repeats like \"aaa\" are easy to guess."
	],
	"password.zxcvbn.warning.sequences": [
		"Sequences like \"abc\" or \"6543\" are easy to guess."
	],
	"password.zxcvbn.warning.shortKeyboardPatterns": [
		"Short keyboard patterns are easy to guess."
	],
	"password.zxcvbn.warning.similarToCommonPassword": [
		"This is similar to a commonly used password."
	],
	"password.zxcvbn.warning.straightRows": [
		"Straight rows of keys are easy to guess."
	],
	"password.zxcvbn.warning.top100CommonPassword": [
		"This is a top-100 common password."
	],
	"password.zxcvbn.warning.top10CommonPassword": [
		"This is a top-10 common password."
	],
	"password.zxcvbn.warning.veryCommonPassword": [
		"This is a very common password."
	],
	"password.zxcvbn.warning.wordByItself": [
		"A word by itself is easy to guess."
	],
	"provider.continueWith": [
		"Continue with ",
		[
			"display_name"
		]
	],
	"provider.continueWithSSO": [
		"Use single sign-on"
	],
	"provider.lastUsed": [
		"Last used"
	],
	"recoveryCodes.entry.content": [
		"Enter one of the backup codes you saved when setting up your authenticator app."
	],
	"recoveryCodes.entry.error.invalidCode": [
		"Invalid backup code, please try again."
	],
	"recoveryCodes.entry.title": [
		"Enter backup code"
	],
	"recoveryCodes.filename.noOrganizationName": [
		"backup-codes"
	],
	"recoveryCodes.filename.withOrganizationName": [
		[
			"organizationName"
		],
		"-backup-codes"
	],
	"recoveryCodes.save.button.copied": [
		"Copied!"
	],
	"recoveryCodes.save.button.copyAll": [
		"Copy all to clipboard"
	],
	"recoveryCodes.save.button.done": [
		"Done"
	],
	"recoveryCodes.save.button.download": [
		"Download .txt file"
	],
	"recoveryCodes.save.content": [
		"This is the only time you will be able to access and save your backup codes."
	],
	"recoveryCodes.save.title": [
		"Save your backup codes!"
	],
	"recoveryCodes.save.toast.copyFailed": [
		"Couldn't copy codes to clipboard"
	],
	"ssoDiscovery.email.error.unknown": [
		"Something went wrong. Try again later or contact your admin for help."
	],
	"ssoDiscovery.email.title": [
		"Enter your email to continue"
	],
	"ssoDiscovery.fallback.button.reset": [
		"Try another method"
	],
	"ssoDiscovery.fallback.content": [
		"Please input the Organization's unique slug to continue. If you don't know the unique slug, log in through another method to view all of your available Organizations."
	],
	"ssoDiscovery.fallback.error.orgNotFound": [
		"Organization not found. Please try again."
	],
	"ssoDiscovery.fallback.error.unknown": [
		"An error occurred. Please try again."
	],
	"ssoDiscovery.fallback.title": [
		"Sorry, we couldn't find any connections"
	],
	"ssoDiscovery.title": [
		"Select a connection to continue"
	],
	"success.title": [
		"Success!"
	],
	"totp.content": [
		"Enter the 6-digit code from your authenticator app."
	],
	"totp.setupQr.content": [
		"Your organization requires an additional form of verification to make your account more secure. If you don’t have an authenticator app, you’ll need to install one first."
	],
	"totp.setupQr.title": [
		"Scan the QR code to link your authenticator app"
	],
	"totp.title": [
		"Enter verification code"
	],
	"watermark.altText": [
		"Stytch by Twilio"
	],
	"watermark.poweredBy": [
		"Powered by"
	]
};

export { messages$1 as messages };
//# sourceMappingURL=en.json.mjs.map
